<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("Language") }}
      </p>
    </div>
    <div class="modal-card-body">
      
        {{$i18n.locale}}
        {{languages}}
        <!-- <b-dropdown v-model="$i18n.locale">
          <b-dropdown-item
          class="language"
            v-for="(lang, i) in languages"
            :key="`Lang${i}`"
            :value="lang.code"
          >
            {{ lang.label }}
          </b-dropdown-item>
        </b-dropdown> -->
       
    </div>
  </div>
</template>

<script>

import config from '@/config';


export default {
  data() {
    return {
      name: "",
      email: "",
      message: "",
      document: null,
    };
  },
  computed: {
     languages() {
      return config.languages;
    },
  },
  async mounted() {
    
  },
  methods: {
    async load() {
      
    },
  },
};
</script>
